import React from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from '@/components/ScrollToTop';
import HomePage from '@/pages/HomePage';
import ServicesPage from '@/pages/ServicesPage';
import ServiceDetailPage from '@/pages/ServiceDetailPage';
import FounderPage from '@/pages/FounderPage';
import BlogsPage from '@/pages/BlogsPage';
import BlogDetailPage from '@/pages/BlogDetailPage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import TermsOfServicePage from '@/pages/TermsOfServicePage';
import SubmissionUFOAnimation from '@/components/SubmissionUFOAnimation';
import { ImageProvider } from '@/context/ImageContext';
import AdminImageModal from '@/components/AdminImageModal';

function App() {
  return (
    <ImageProvider>
      <Router>
        <ScrollToTop />
        <SubmissionUFOAnimation />
        <AdminImageModal />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/*" element={<ServiceDetailPage />} />
          <Route path="/founder" element={<FounderPage />} />
          <Route path="/blogs" element={<BlogsPage />} />
          <Route path="/blog/:slug" element={<BlogDetailPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </Router>
    </ImageProvider>
  );
}

export default App;
